module.exports = __webpack_public_path__ + "static/media/carousel_01.951876c0.png";